/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsEGameOrientation, FxIdDomainSettingsEGameOrientationFromJSONTyped, FxIdDomainSettingsEGameOrientationToJSON, } from './FxIdDomainSettingsEGameOrientation';
export function FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsEGameOrientation(json)) {
        return FxIdDomainSettingsEGameOrientationFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsEGameOrientation(value)) {
        return FxIdDomainSettingsEGameOrientationToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation.js.map